import * as React from "react";

interface CopyIconProps {
	fillColor?: string;
	iconColor: string;
	style: any;
	onClick?: () => void; // note: needed for "react-copy-to-clipboard" (the prop is overridden on render)
	onMouseEnter?: () => void;
	onMouseLeave?: () => void;
}

class CopyIcon extends React.Component<CopyIconProps, any> {
	constructor(props: CopyIconProps) {
		super(props);
	}

	state = {
		fillColor: null,
	};

	addHoverColor(e) {
		this.setState({ fillColor: this.props.fillColor || null });
		this.props.onMouseEnter(); // fire the prop passed from the parent
	}

	removeHoverColor(e) {
		this.setState({ fillColor: null });
		this.props.onMouseLeave(); // fire the prop passed from the parent
	}

	render() {
		const { onClick, iconColor, style } = this.props;

		const { fillColor } = this.state;

		return (
			<svg
				width="38px"
				height="38px"
				viewBox="0 0 38 38"
				version="1.1"
				style={style}
				onClick={onClick}
				onMouseOver={this.addHoverColor.bind(this)}
				onMouseLeave={this.removeHoverColor.bind(this)}
			>
				<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="06" transform="translate(-1089.000000, -1026.000000)" fillRule="nonzero">
						<g id="Copy_Unselected" transform="translate(1089.000000, 1026.000000)">
							<circle
								id="Oval"
								style={{
									fill: fillColor || "transparent",
									transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
								}}
								cx="19"
								cy="19"
								r="19"
							/>
							<path
								d="M20.6446996,27 L9.31806506,26.971374 C9.13990944,26.966696 8.99838902,26.8202155 9.00001385,26.6421756 L9.03153244,15.3263359 C9.03142406,15.1504841 9.17080717,15.0061702 9.34671832,15 L20.6733528,15.028626 C20.8537551,15.028626 21,15.1747315 21,15.3549618 L20.9684814,26.6708015 C20.9692447,26.7573522 20.9355601,26.8406605 20.8748385,26.9023979 C20.8141169,26.9641353 20.7313328,26.9992441 20.6446996,27 Z M9.64471225,26.3158397 L20.3180524,26.3444656 L20.3467056,15.6812977 L9.67336551,15.6526718 L9.64471225,26.3158397 Z"
								id="Shape"
								fill={iconColor}
							/>
							<path
								d="M27.6453773,24 L23.1679056,24 C22.9863836,24 22.8392309,23.8540765 22.8392309,23.6740708 C22.8392309,23.4940651 22.9863836,23.3481416 23.1679056,23.3481416 L27.3167026,23.3481416 L27.3368844,11.6890257 L15.6631671,11.6575764 L15.6631671,13.5502529 C15.6631671,13.7302586 15.5160145,13.8761821 15.3344925,13.8761821 C15.2453186,13.8777476 15.159332,13.8433092 15.0962667,13.7807707 C15.0332014,13.7182322 14.9984729,13.6329638 15.0000516,13.5445349 L15.0000516,11.3259292 C15.0000516,11.1459235 15.1472042,11 15.3287262,11 L27.6713253,11.0314493 C27.8528473,11.0314493 28,11.1773728 28,11.3573785 L27.9682858,23.6683528 C27.9698286,23.7547984 27.9366715,23.8383099 27.8761116,23.9005087 C27.8155517,23.9627076 27.7325516,23.9984967 27.6453773,24 Z"
								id="Shape"
								fill={iconColor}
							/>
						</g>
					</g>
				</g>
			</svg>
		);
	}
}

export default CopyIcon;



// WEBPACK FOOTER //
// ./src/components/Example/CopyIcon.tsx